import { Link } from "react-router-dom";

import type { Inbox } from "../../../api/types";
import { Button } from "../../../ui/Button";
import { firstCardOf } from "../card/walk";
import { ageWords, formatWhen, plural } from "../shared/format";
import { Beads } from "./Beads";
import { cardPath } from "./InboxEntryRow";
import { engineerValue } from "./InboxFilters";

interface HandOverListProps {
  inbox: Inbox;
  onlyEngineer: string | undefined;
  onPickEngineer: (value: string) => void;
}

/** The hand-overs that came in: who sent them, how many cards, how many Unsure, how old. A hand-over is a signal, not a gate. */
export function HandOverList({ inbox, onlyEngineer, onPickEngineer }: HandOverListProps) {
  if (inbox.hand_overs.length === 0) return null;
  return (
    <section aria-labelledby="ra-handovers-title" className="ra-handovers">
      <h2 id="ra-handovers-title">Hand-overs waiting</h2>
      <ul className="ra-handovers__list">
        {inbox.hand_overs.map((handOver) => {
          // The first card of the server's walk, not of the list: waiting homes come before what hangs on them (DEC-1016-52, UI-04).
          const first = firstCardOf(inbox, handOver);
          const value = engineerValue(handOver.engineer);
          return (
            <li key={handOver.id} className="ra-handover">
              <div className="ra-handover__text">
                <strong>{handOver.engineer.display}</strong> sent {plural(handOver.count, "card")}
                {handOver.unsure > 0 ? `, ${handOver.unsure} Unsure` : ""}. <span className="muted">Sent {formatWhen(handOver.sent_at)} ({ageWords(handOver.age_days)}).</span>
              </div>
              <Beads total={handOver.count} unsure={handOver.unsure} />
              <div className="row">
                {first ? (
                  <Link to={cardPath(first)} state={{ shown: true }}>
                    Open the first card
                  </Link>
                ) : (
                  <span className="muted">Its cards are not waiting any more.</span>
                )}
                {onlyEngineer !== value && (
                  <Button variant="quiet" onClick={() => onPickEngineer(value)}>
                    Show only {handOver.engineer.display}
                  </Button>
                )}
              </div>
            </li>
          );
        })}
      </ul>
    </section>
  );
}
